import { useContext, useMemo } from "react";
import ComponentsContext from "../../Context/Display/Components/ComponentsContext";
import { getComponentByProperty } from "../../Components/Display/Components/utils";

function useComponents() {
    const { state, dispatch } = useContext(ComponentsContext);

    return [state, dispatch];
}

export function useSelectedComponent() {
    const [state] = useComponents();
    const { selectedComponentIndex } = state;

    const selectedComponent = useMemo(
        () => getComponentByProperty(state.components, "treeIndex", selectedComponentIndex),
        [state.components, selectedComponentIndex]
    );

    return selectedComponent;
}

export default useComponents;